import { STORAGE_KEYS } from '@/constants/storage';
import { encryptedStorage } from '@/utils/encrypted-storage';

export async function readTutorialGuideCompleted(): Promise<boolean> {
  return (await encryptedStorage.get<boolean>(STORAGE_KEYS.TUTORIAL_GUIDE_COMPLETED)) === true;
}

export async function writeTutorialGuideCompleted(): Promise<void> {
  await encryptedStorage.set(STORAGE_KEYS.TUTORIAL_GUIDE_COMPLETED, true);
}
